<template>
  <div class="ranking-list" v-loading="loading">
    <div class="flex-row flex-between ranking_title">
      <div class="menu-left">
        <img v-if="type == 3" class="left-title" src="./img/t_guess.png" />
        <img v-if="type == 1" class="left-title" src="./img/t-zb.png" />
        <img v-if="type == 2" class="left-title" src="./img/t-fh.png" />
        <div class="left-info flex-row">
          <div>{{ info.content }}</div>
          <el-tooltip class="item" effect="dark" placement="bottom">
            <template slot="content">
              <div v-if="type == 3">
                <p style="padding: 0.1rem 0rem">竞猜排行榜规则：</p>
                <p>1.时间为周一0点开始至当周周日24点结束，下周零点自动刷新新的排名。</p>
                <p>
                  2.当周在解说直播间参与竞猜(鹰选)活动，用鹰钻进行竞猜(鹰选)，投注结果正确与否，最终结果与投注内容一致，<br />按照对应赔率获得鹰钻。排行榜统计本周各个用户竞猜获胜的鹰钻数量，排位名称按照数量由高到低降序排名。
                </p>
                <p>3.为保障活动长久公平，以净盈利为统计规则。</p>
                <p>4.对于赔率错误，赔率不合理的竞猜(鹰选)，会清除盈利，退回投注鹰钻。</p>
                <p>5.奖品发放请获奖用户凭个人中心截图和中奖名单截图联系在线客服，客服会安排奖品发放。</p>
                <p>6.最终解释权归于猎鹰直播。</p>
              </div>
              <div v-if="type == 1">
                <p style="padding: 0.1rem 0rem">主播达人榜规则：</p>
                <p>1.日榜：统计当日凌晨至现在，全站主播的新增粉丝总数量,对主播由高到低排名；</p>
                <p>2.周榜：统计每周一凌晨至现在，全站主播的新增粉丝总数量,对主播由高到低排名；</p>
                <p>3.月榜：统计每月1号凌晨至现在，全站主播的新增粉丝总数量,对主播由高到低排名；</p>
              </div>
              <div v-if="type == 2">
                <p style="padding: 0.1rem 0rem">富豪达人榜规则：（消费1克拉 =10贡献值）</p>
                <p>1.日榜：统计当日凌晨至现在，全站用户的消费贡献值,按用户贡献值大小，由高到低排名；</p>
                <p>2.周榜：统计当前周一凌晨至现在，全站用户的消费贡献值,按用户贡献值大小，由高到低排名；</p>
                <p>3.月榜：统计当前月1号凌晨至现在，全站用户的消费贡献值,按用户贡献值大小，由高到低排名；</p>
              </div>
            </template>
            <img src="./img/help.png" />
          </el-tooltip>
        </div>
        <div class="guess_down_time" v-if="type == 3">距离下次榜单统计时间：{{ weekDownTime }}</div>
      </div>
      <div class="flex-row menu-list">
        <template v-if="type == 3">
          <div class="flex-row menu-item select">周榜</div>
        </template>
        <template v-else>
          <!-- <div class="flex-row menu-item" :class="{ select: date_type == 1 }" @click="changeDateType(1)">日榜</div>
          <div class="flex-row menu-item" :class="{ select: date_type == 2 }" @click="changeDateType(2)">周榜</div> -->
          <div class="flex-row menu-item select">月榜</div>
        </template>
      </div>
    </div>
    <div class="flex-row justify-between align-end bl">
      <div>
        <RankingTop :needFocusBtn="needFocusBtn" v-if="listData.length > 1" :number="2" :item="listData[1]" @tofollow="tofollow"></RankingTop>
      </div>
      <div style="top: -0.2rem">
        <RankingTop :needFocusBtn="needFocusBtn" v-if="listData.length > 0" :number="1" :item="listData[0]" @tofollow="tofollow"></RankingTop>
      </div>
      <div>
        <RankingTop :needFocusBtn="needFocusBtn" v-if="listData.length > 2" :number="3" :item="listData[2]" @tofollow="tofollow"></RankingTop>
      </div>
    </div>

    <div class="" v-for="(item, index) in listData" :key="index">
      <RankingItem :style="{ background: index % 2 === 0 ? '#ffffff' : '#F9F9FB' }" :needFocusBtn="needFocusBtn" :type="type" :index="index" :item="item" @tofollow="tofollow"></RankingItem>
    </div>
    <!-- 
		<div class="ranking-footer">
			<div>活动说明：</div>
			<div v-html="info.content"></div>
		</div>
		-->
    <!--
		<RankingDialog  ref="RankingDialog"></RankingDialog>
		--></div>
</template>

<script>
import { format } from "@/util/time";
import RankingTop from "./ranking-top";
import RankingItem from "./ranking-item";
import RankingDialog from "@/components/dialog/RankingDialog";
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    RankingTop,
    RankingItem,
    RankingDialog,
  },
  props: {
    needFocusBtn: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  data() {
    return {
      loading: false,
      st: 60000 * 5,
      timeT: null,
      // 1,日榜 2,周榜 3,月榜,主播和富豪的的日榜，周榜已隐藏。因此，默认调月榜
      date_type: 3, 
      listData: [],
      nobleList: [],
      info: {
        content: "",
      },
      tabPic: [require("./img/noble1.png"), require("./img/noble2.png"), require("./img/noble3.png")],
      defaultHeader: require("./img/head-default.png"),
      //下周一0点的时间戳
      nextMondayTime: 0,
      //竞猜榜倒计时
      weekDownTime: "",
      //全局定时器句柄
      weekTimer: 0,
    };
  },
  async created() {
    await this.getNobleList();
    this.getAclist();
    this.timeT = setInterval(() => {
      this.getAclist();
    }, this.st);
    this.getInfo();
  },
  destroyed() {
    this.timeT && clearInterval(this.timeT);
    clearTimeout(this.weekTimer);
  },
  mounted() {
    //竞猜榜倒计时
    this.countWeekDownTime();
  },
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLogin", "changeLoginType"]),

    /**
     * 取下周一的时间戳
     */
    getNextMonday() {
      //计算与下周一间隔几天
      let date_obj = new Date();
      let today_num = date_obj.getDay();
      if (today_num == 0) {
        today_num = 7;
      }
      let day_diff = 8 - today_num;
      let target_time = date_obj.getTime() + day_diff * 3600 * 24 * 1000;
      //格式化，得到下周一的0点0分0秒
      let monday_time = format(target_time, "yyyy-MM-dd 00:00:00");
      this.nextMondayTime = new Date(monday_time).getTime();
    },

    /**
     * 与下周一的倒计时
     */
    countWeekDownTime() {
      if (this.nextMondayTime <= 0) {
        this.getNextMonday();
      }
      //当前的时间差
      let now_time = Math.floor((this.nextMondayTime - new Date().getTime()) / 1000);
      //天
      let days = Math.floor(now_time / (3600 * 24));
      //小时
      let hour = Math.floor((now_time - days * 3600 * 24) / 3600);
      //分钟
      let minute = Math.floor((now_time - days * 3600 * 24 - hour * 3600) / 60);
      //秒
      let second = now_time - days * 3600 * 24 - hour * 3600 - minute * 60;
      //双日期处理
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      this.weekDownTime = days + "天" + hour + "小时" + minute + "分" + second + "秒";
      this.weekTimer = setTimeout(() => {
        this.countWeekDownTime();
      }, 1000);
    },

    async getNobleList() {
      const {
        data: { data },
      } = await post({ url: "/api/noble/getNobleList" });
      let nobleList = data || [];
      for (let i = 0; i < nobleList.length; i++) {
        nobleList[i].pic = this.tabPic[i];
      }
      this.nobleList = nobleList;
      // console.log("nobleList: ",nobleList);
    },

    changeDateType(v = 3) {
      this.date_type = v;
      this.getAclist();
    },

    getAclist() {
      this.loading = true;
      //如果是竞猜达人榜，则只有周榜
      if (this.type == 3) {
        this.date_type = 2;
      }
      let data = {
        date_type: this.date_type,
        type: this.type,
      };
      if (this.userInfo && this.userInfo.id) {
        data.user_id = this.userInfo.id;
      }
      post({
        url: "/api/live/top_user",
        data: data,
      })
        .then(({ data: { data } }) => {
          // console.log("---->>>>", data);
          let listData = data.top_user || [];
          let nobleList = [...this.nobleList];
          listData.forEach((v) => {
            switch (this.type) {
              case 1:
                v.stat_label = "粉丝";
                break;
              case 2:
                v.stat_label = "贡献值";
                break;
              case 3:
                v.stat_label = "盈利";
                break;
            }
            if (v.nickname.length > 6) {
              // v.nickname = v.nickname.slice(0,6) + "..."
            }
            let temp_stat = v.stat;
            if (this.type == 3) {
              temp_stat = temp_stat / 100;
            }
            v.stat = Number(temp_stat) || 0;
            v.isXWYD = false;
            if (v.stat == 0) {
              v.avatar = this.defaultHeader;
              v.nickname = "虚位以待";
              v.isXWYD = true;
            } else if (v.stat && v.stat > 9999) {
              v.stat = Number(v.stat / 10000).toFixed(2) + "w";
            }
            nobleList.some((n) => {
              if (n.id && v.noble_id && n.id == v.noble_id) {
                v.noble_src = n.pic || "";
                return true;
              }
            });
            // v.noble_src = this.tabPic[0]
          });
          // this.protocol = data;
          // listData[5]["noble_src"] = this.nobleList[0]['pic']
          // listData = [listData[0]];
          let len = listData.length;
          if (len < 20) {
            for (let i = len; i < 20; i++) {
              listData.push({
                nickname: "虚位以待",
                stat: 0,
                isXWYD: true,
              });
            }
          }
          this.listData = listData;
          //console.log("listData： ",this.listData)
          setTimeout(() => {
            this.loading = false;
          }, 50);
        })
        .catch((err) => {
          console.warn("err: ", err);
          this.loading = false;
        });
    },

    getInfo() {
      post({
        url: "/api/live/top_user_desc",
        data: {
          id: this.type,
        },
      })
        .then(({ data: { data } }) => {
          this.info = data;
        })
        .catch((err) => {});
    },

    tofollow(val) {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      if (this.userInfo.id == val.uid) {
        this.$message({
          message: "不能关注自己",
          type: "error",
          customClass: "ly-error",
        });
        return;
      }
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: val.uid,
          // device: str
        },
      }).then(({ data: { data } }) => {
        let text = data.type == 1 ? "关注成功" : "取消关注";
        this.$message({
          message: text,
          type: "success",
          customClass: "ly-success",
        });
        let index = "";
        this.listData.some((v, i) => {
          if (v.uid == val.uid) {
            index = i;
            return true;
          }
        });
        let stat = Number(this.listData[index]["stat"]) || 0;
        if (data.type == 1) {
          this.$set(this.listData[index], "is_follow", 1);
          this.$set(this.listData[index], "stat", stat + 1);
        } else {
          this.$set(this.listData[index], "is_follow", 2);
          this.$set(this.listData[index], "stat", stat - 1);
        }
      });
    },

    showDialog() {
      this.$refs.RankingDialog.open(this.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.ranking-list {
  line-height: 0.2rem;
  font-size: 0.14rem;
  padding: 0.2rem 0.1rem;
  .menu-left {
    padding-top: 0.05rem;
    .guess_down_time {
      clear: both;
      width: 100%;
      height: 0.25rem;
      line-height: 0.25rem;
      overflow: hidden;
      font-size: 0.14rem;
      color: #999;
    }
    img.left-title {
      height: 0.26rem;
    }
    .left-info {
      color: #999999;
      padding: 0.1rem 0rem;
      img {
        margin-left: 0.05rem;
        width: 0.2rem;
        height: 0.2rem;
      }
      p {
        padding: 0.05rem 0rem;
      }
    }
  }

  .ranking_title {
    position: relative;
  }
  .menu-list {
    justify-content: flex-start;
    height: 0.35rem;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;

    .menu-item {
      border-radius: 0.5rem;
      cursor: pointer;
      color: #999999;
      border: 1px solid #dbdbdb;
      margin-left: 0.1rem;
      align-items: center;
      justify-content: center;
      height: 0.35rem;
      width: 0.7rem;
      &.select {
        color: #ffffff !important;
        background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%) !important;
        // border-color : transparent !important;
        border: 0rem;
      }
      &:hover,
      &.active {
        color: #02a8a2;
        border: 1px solid #02a8a2;
      }
    }
  }

  .bl {
    position: relative;
    padding: 0.3rem 0rem;
    padding-bottom: 0rem;
    & > div {
      position: relative;
      width: 333.33%;
    }
  }
}
</style>